import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-msg-generator',
  templateUrl: './icc-msg-generator.component.html',
  styleUrls: ['./icc-msg-generator.component.less'],
})
export class IccMsgGeneratorComponent implements OnInit, OnChanges {
  constructor() {}
  @Input() options: Array<any>;

  // 当前激活的tab的下标
  activeIndex: number;

  // icc-side-menu 图文列表的选中对象
  selectedMenuItem: any = {
    _id: new Date().getTime(),
    selected: true,
    content: '',
    title: '',
    mediaList: [],
  };

  // formTypes = ['input', 'textarea', 'editor', 'video', 'audio', 'image'];

  ngOnInit() {
    this.init();
  }

  ngOnChanges(): void {
    this.init();
  }

  /*
   * 初始化配置
   */
  init() {
    if (!this.options) {
      this.options = [];
      return;
    }
    this.options.forEach((tabData, tablIndex) => {
      if (tabData.hasOwnProperty('active') && tabData.active === true) {
        this.activeIndex = tablIndex;
      }
      if (!tabData.hasOwnProperty('disabled')) {
        tabData.disabled = false;
      }
      // 当左侧guide的内容需要在右侧form展示时，则为true，此时form中的双向绑定字段使用index指定的字段， 默认为false
      if (!tabData.hasOwnProperty('useGuideIndex')) {
        tabData.useGuideIndex = false;
      }
      if (tabData.guide && !tabData.guide.hasOwnProperty('config')) {
        tabData.guide.config = tabData.guide.config || {};
      }
    });
  }
  /*
   * 根tabset的change事件
   */
  rootTabChange(index: number) {
    this.options.forEach((tabOptions, tabIndex) => {
      tabOptions.active = tabIndex === index ? true : false;
    });
    this.activeIndex = index;
  }
  /*
   * 根据active更新tabset的激活项，需要手动调用
   */
  updateActiveIndex() {
    this.options.forEach((tabData, tablIndex) => {
      if (tabData.hasOwnProperty('active') && tabData.active === true) {
        this.activeIndex = tablIndex;
      }
    });
  }
  /*
   * 手动更新options
   */
  setOptions(newOptions: any) {
    this.options = newOptions;
  }
}
